module.exports = __webpack_public_path__ + "img/101.9.6e90428e.png";